import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { UIModule } from 'libraries/ui/ui.module';
import { LoginFormModule } from 'libraries/module/formbuilder/forms/login-form/login-form.module';
import { LoginComponent } from './login.component';
import { GuardService } from '../../services/guard/guard.service';
import { AuthModule } from 'libraries/service/auth/auth.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { TextFormFieldModule } from 'libraries/module/formbuilder/fields/text-form-field/text-form-field.module';
import { AuthFormComponent } from './auth-form/auth-form.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        UIModule,
        LoginFormModule,
        AuthModule,
        LoaderModule,
        NotificationModule,
        TextFormFieldModule
    ],
    declarations: [
        LoginComponent,
        AuthFormComponent
    ],
    exports: [
        LoginComponent
    ],
    providers: [
        GuardService
    ]
})
export class LoginModule { }
